module.exports = __webpack_public_path__ + "static/img/img-9.adeac31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-9.png
// module id = GJc3
// module chunks = 1